const getNotificationPreferences = state => state.automationTab.notificationPreferences;
export default getNotificationPreferences;